import { call, put, select } from 'redux-saga/effects';

import api from 'api';
import { ICompleteWorkout } from 'api/components/PersonalPlan/types';

import { notifyError } from 'store/notifications/actions';
import { setCurrentPlanCompletion, workoutComplete } from 'store/personalPlan/actions';
import {
    selectCurrentDay,
    selectPlanDays,
    selectTotalPlanDays,
    selectWorkout,
    selectYogaType,
} from 'store/personalPlan/selectors';

import type { YogaType } from 'constants/personalPlan';

import { isLastDayOfThePlan } from 'helpers/workout';

import { IWorkoutExtended } from 'types/personalPlan';

export function* completeWorkout({ payload }: ReturnType<typeof workoutComplete>) {
    const { fact_kcal, fact_duration, onWorkoutCompleted, workoutDay } = payload;

    try {
        const totalDays: number = yield select(selectTotalPlanDays);
        const currentDay: number = yield select(selectCurrentDay);
        const days: IWorkoutExtended[] = yield select(selectPlanDays);
        const yogaType: YogaType = yield select(selectYogaType);
        const { exercise_count } = yield select(selectWorkout);
        const { workout_id, type, day_number } = days[currentDay - 1];

        yield call(api.personalPlan.completeWorkout, {
            day_number,
            workout_id,
            workout_type: type,
            fact_kcal,
            fact_duration,
            yoga_type: yogaType,
            exercises_count: exercise_count,
        } as ICompleteWorkout);

        if (isLastDayOfThePlan(workoutDay, totalDays)) {
            yield put(setCurrentPlanCompletion(true));
        }

        onWorkoutCompleted();
    } catch (error: any) {
        yield put(notifyError({ message: 'basics.appError' }));
    }
}
